import { Typography } from "@remo-co/ui-core/src/components/Typography";
import VideoPlayerIFrame from "modules/videoPlayer/VideoPlayerIFrame";
import { getEmbeddedVideoURL } from "helpers/videoHelper";

interface Props {
  title: string;
  url: string;
}

const VideoTutorials = ({ title, url }: Props) => (
  <>
    <Typography variant="h4">{title}</Typography>
    <VideoPlayerIFrame src={getEmbeddedVideoURL(url) || ""} allowFullScreen />
  </>
);

export default VideoTutorials;
